@if (isRmbRmc) {
<p>{{ "OTHER_COVERAGE_STATICTEXT14" | globalTranslate }}</p>
}
<p class="person-label">{{ selectedIndividual | fullname }}</p>
<nh-form
  [topLevelName]="'sp'"
  [individuals]="checkForDropdown ? finalListIndvs : individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  class="label-section"
  [topLevelLabelSize]="false"
  [topLevelCol9]="true"
  topLevelQuestion="{{ 'MANDATORY_PAYMENTS_STATIC_TEXT1' | globalTranslate }}"
  topLevelHintText="{{ 'MANDATORY_PAYMENTS_STATIC_TEXT2' }}"
  [individualQuestion]="individualQues | globalTranslate"
  [hintText]="hintText"
  popupText="{{ 'MANDATORY_PAYMENTS_STATIC_TEXT3' | globalTranslate }}"
  (validate)="onValidate($event)"
  mandatory="true"
>
  <section formGroupName="data">
    <h1 class="section-header">
      {{ "MANDATORY_PAYMENTS_STATIC_TEXT4" | globalTranslate }}
    </h1>
    <hr />
    <div>
      <nh-field
        id="sp_supportKindCode"
        label="{{ 'MANDATORY_PAYMENTS_STATIC_TEXT5' | globalTranslate }} {{
          selectedIndividual | fullname
        }}{{ 'MANDATORY_PAYMENTS_STATIC_TEXT6' | globalTranslate }}"
        class="label-section"
      >
        <select
          nhTranslate
          name="supportKindCode"
          [items]="
            tableCodeValue('CHILDSUPMANEXPENSETYPE', 'data.supportKindCode')
          "
          formControlName="supportKindCode"
          [attr.aria-label]="
            ('MANDATORY_PAYMENTS_STATIC_TEXT5' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('MANDATORY_PAYMENTS_STATIC_TEXT6' | globalTranslate)
          "
          required
        ></select>
      </nh-field>
      <nh-field
        id="sp_expenseAmount"
        label="{{ 'OTHER_INCOME_SATIC_TEXT26' | globalTranslate }} {{
          selectedIndividual | fullname
        }}{{ 'UTILITIES_EXPENSES_STATIC_TEXT6' | globalTranslate }}"
        class="label-section"
      >
        <div class="hint">
          {{ "MANDATORY_PAYMENTS_STATIC_TEXT7" | globalTranslate }}
        </div>
        <nh-input-group prepend="$">
          <input
            nh
            type="decimal"
            maxlength="7"
            name="expenseAmount"
            formControlName="expenseAmount"
            class="form-control"
            [attr.aria-label]="
              ('OTHER_INCOME_SATIC_TEXT26' | globalTranslate) +
              ' ' +
              (selectedIndividual | fullname) +
              ' ' +
              ('UTILITIES_EXPENSES_STATIC_TEXT6' | globalTranslate)
            "
            required
          />
        </nh-input-group>
      </nh-field>
    </div>
  </section>
</nh-form>